import styled from 'styled-components';
import { Checkbox as CheckboxComponent } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(TextLayoutComponent.Bold)`
  &&& {
    margin-bottom: 20px;
    font-size: 20px;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const Checkbox = styled(CheckboxComponent)`
`;

export const FeatureFlagName = styled(TextLayoutComponent)`
  &&& {    
    font-size: 14px;
    width: 20rem;
  }
`;
